import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainRoutingModule } from './main-routing.module';
import { MainComponentComponent } from './components/main-component/main-component.component';
import { SharedModule } from '@shared/shared.module';

@NgModule({
  declarations: [MainComponentComponent],
  imports: [
    CommonModule,
    MainRoutingModule,
    SharedModule
  ],
})
export class MainModule { }
